<template>
  <div class="essay-correction">
    <div class="header-actions">
      <h2>Koreksi Essay (Subtes)</h2>
      <button class="btn-secondary" @click="goBack">Kembali</button>
    </div>

    <div v-if="loading" class="loading-state">Memuat data...</div>
    <div v-else-if="error" class="error-message">{{ error }}</div>
    <div v-else-if="answers.length === 0" class="empty-state">
      Tidak ada jawaban essay untuk tes ini.
    </div>
    
    <div v-else class="card table-card">
      <table class="admin-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Pertanyaan</th>
            <th>Kunci Jawaban (Poin)</th>
            <th>Jawaban Peserta</th>
            <th>Skor Saat Ini</th>
            <th>Ubah Skor</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(answer, index) in answers" :key="answer.id">
            <td>{{ index + 1 }}</td>
            <td>{{ answer.question_text }}</td>
            <td>
              <ul class="options-list">
                <li v-for="opt in answer.options" :key="opt.id">
                  {{ opt.text }} <span class="score-badge">(Skor: {{ opt.score }})</span>
                </li>
              </ul>
            </td>
            <td><strong>{{ answer.answer_text || '-' }}</strong></td>
            <td class="text-center">
              <span class="current-score">{{ answer.score !== null ? answer.score : 0 }}</span>
            </td>
            <td>
              <div class="score-actions">
                <button 
                  v-for="val in [0, 1, 2]" 
                  :key="val"
                  :class="['btn-score', { active: answer.score === val }]"
                  @click="updateScore(answer.id, val, index)"
                >
                  {{ val }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import apiClient from '@/services/api.js';

const route = useRoute();
const router = useRouter();

const participantId = route.params.id;
const testId = route.params.sessionId;

const answers = ref([]);
const loading = ref(true);
const error = ref(null);

const fetchAnswers = async () => {
  try {
    loading.value = true;
    const response = await apiClient.get(`/admin/participants/${participantId}/tests/${testId}/essay-answers`);
    answers.value = response.data;
  } catch (err) {
    console.error(err);
    error.value = "Gagal memuat jawaban essay.";
  } finally {
    loading.value = false;
  }
};

const updateScore = async (answerId, newScore, index) => {
  try {
    const response = await apiClient.put(`/admin/answers/${answerId}/score`, { score: newScore });
    // Update local state
    answers.value[index].score = response.data.score;
    // alert("Skor berhasil diupdate!"); // Opsional, bisa dihilangkan jika terlalu berisik
  } catch (err) {
    console.error(err);
    alert("Gagal mengupdate skor.");
  }
};

const goBack = () => {
  router.push(`/admin/participant/${participantId}`);
};

onMounted(() => {
  fetchAnswers();
});
</script>

<style scoped>
.essay-correction {
  padding: 20px;
}
.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.options-list {
  padding-left: 20px;
  margin: 0;
}
.score-badge {
  color: #16a085;
  font-weight: bold;
  font-size: 0.9em;
}
.current-score {
  font-size: 1.2rem;
  font-weight: bold;
  background: #f1f2f6;
  padding: 5px 15px;
  border-radius: 4px;
}
.score-actions {
  display: flex;
  gap: 8px;
}
.btn-score {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-score:hover {
  background: #eee;
}
.btn-score.active {
  background: #2ecc71;
  color: white;
  border-color: #27ae60;
}
.btn-secondary {
  padding: 8px 16px;
  background-color: #95a5a6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.btn-secondary:hover {
  background-color: #7f8c8d;
}
.table-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  overflow-x: auto;
  padding: 15px;
}
.admin-table {
  width: 100%;
  border-collapse: collapse;
}
.admin-table th, .admin-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  text-align: left;
}
.admin-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}
.text-center {
  text-align: center;
}
</style>
